import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {ArcTimeLineValidationTypes, documentTypes, validationTypes} from '../.././util/uiconstants';
import empty from 'uuid/v4';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */

export default function arcValidationsReducer(state = initialState.arcValidations, action) {
	switch (action.type) {
		case types.GET_ARCTIMELINE_VALIDATIONS: {
			if (!action.response) return state;

			const grouped = groupResponse([...action.response]);
			return grouped;
		}
		case types.GET_ARCTIMELINE_VALIDATIONS_AFTER_RESPONSE: {
			return JSON.parse(
				JSON.stringify([
					{
						id: '8b5f831b-ee19-4a6d-8d88-acd46cb1d206',
						validationtypeid: 4,
						validationentityid: 1,
						validationcount: 66,
						validationid: 4,
						validationname: 'Parent 11',
						validationgroupid: 0,
						uidisplayorder: 4,
						documenttypeid: 0,
						documentid: '49dea022-3c62-ea11-a94c-28187830cc29',
						children: [
							{
								id: '1adaea8e-725a-4a0e-8d95-c822b80649ca',
								validationtypeid: 4,
								validationentityid: 149268,
								validationcount: 52,
								validationid: 4,
								validationname: 'Sub Parent 11',
								validationgroupid: 0,
								uidisplayorder: 0,
								documenttypeid: 0,
								documentid: '49dea022-3c62-ea11-a94c-28187830cc29',
								children: [
									{
										id: 'e9f09434-7133-4c96-ba7f-4f5ac1898db6',
										validationtypeid: 4,
										validationentityid: 214106,
										validationcount: 23,
										validationid: 4,
										validationname: 'Resolve Remaining Document Conflicts',
										validationgroupid: 0,
										uidisplayorder: 0,
										documenttypeid: 0,
										documentid: '49dea022-3c62-ea11-a94c-28187830cc29',
										children: [
											{
												id: 'e9f09434-7133-4c96-ba7f-4f5ac1898db6',
												validationtypeid: 4,
												validationentityid: 2044385,
												validationcount: 24,
												validationid: 4,
												validationname: 'Resolve Remaining Document Conflicts',
												validationgroupid: 0,
												uidisplayorder: 0,
												documenttypeid: 0,
												documentid: '49dea022-3c62-ea11-a94c-28187830cc29',
												children: null
											}
										]
									},
									{
										id: 'e9f09434-7133-4c96-ba7f-4f5ac1898db6',
										validationtypeid: 4,
										validationentityid: 214106,
										validationcount: 3,
										validationid: 5,
										validationname: 'Resolve Remaining Document Conflicts',
										validationgroupid: 0,
										uidisplayorder: 0,
										documenttypeid: 0,
										documentid: '49dea022-3c62-ea11-a94c-28187830cc29',
										children: null
									}
								]
							},
							{
								id: '1adaea8e-725a-4a0e-8d95-c822b80649ca',
								validationtypeid: 4,
								validationentityid: 148896,
								validationcount: 78,
								validationid: 4,
								validationname: 'Sub Parent 11',
								validationgroupid: 0,
								uidisplayorder: 0,
								documenttypeid: 0,
								documentid: '49dea022-3c62-ea11-a94c-28187830cc29',
								children: null
							},
							{
								id: '1adaea8e-725a-4a0e-8d95-c822b80649ca',
								validationtypeid: 4,
								validationentityid: 148896,
								validationcount: 1,
								validationid: 5,
								validationname: 'Sub Parent 11',
								validationgroupid: 0,
								uidisplayorder: 0,
								documenttypeid: 0,
								documentid: '49dea022-3c62-ea11-a94c-28187830cc29',
								children: null
							}
						]
					}
				])
			);
		}
		case types.GET_ARCTIMELINE_GROUP_VALIDATION: {
			if (!action.response) return state;

			const byGroup = groupResponse([...action.response]);
			let groups = {...state};
			groups[action.groupId] = byGroup[action.groupId];
			return groups;
		}
		case types.CLEAN_ARCTIMELINE_VALIDATION: {
			return {};
		}
		case types.POST_ARCTIMELINE_VALIDATION: {
			return state;
		}
		default:
			return state;
	}
}

//Check if item should be count
const isItemValid = (item) => {
	if (
		(item.validationSubGroupId === ArcTimeLineValidationTypes.IncompleteCanvasFormResponses &&
			item.documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL) ||
		(item.validationSubGroupId === ArcTimeLineValidationTypes.CanvasFormComment && item.documentId === empty())
	) {
		return false;
	}

	//Removing validation 60 for finalize evidence.
	//This scenario if for the inline comments that are included in validation type 62/120.
	if (
		item?.validationTypeId === validationTypes.CanvasFromComments &&
		item?.documentTypeId !== documentTypes.GUIDEDWORKFLOW
	)
		return false;

	return true;
};

//Group the validation items by their group parent.
const groupResponse = (list) => {
	var result = [];
	var docList = new Set();
	list.reduce(function(res, value) {
		if (!isItemValid(value)) return res;
		if (value.validationSubGroupId === ArcTimeLineValidationTypes.PersonInCharge) return res;
		if (!res[value.validationSubGroupId]) {
			res[value.validationSubGroupId] = {
				validationsubgroupid: value.validationSubGroupId,
				validationcount: 0,
				validationgroupid: value.validationGroupId,
				id: value.id,
				validationTypeId: value.validationTypeId
			};
			result.push(res[value.validationSubGroupId]);
		}
		switch (value.validationSubGroupId) {
			case ArcTimeLineValidationTypes.IncompleteCanvasFormResponses:
				docList.add(value.documentId);
				res[value.validationSubGroupId].validationcount = docList.size;
				break;
			case ArcTimeLineValidationTypes.IndependenceCompliance:
				value.validationTypeId === validationTypes.IndependenceViewTemplateNotSubmitted
					? res[value.validationSubGroupId].validationcount++
					: (res[value.validationSubGroupId].validationcount += value.validationCount);
				break;
			case ArcTimeLineValidationTypes.CanvasFormComment:
			case ArcTimeLineValidationTypes.AddressAllOpenReviewNotes:
				if (
					//only CanvasFormComment, creates it as AddressAllOpenReviewNotes, then delete old one
					value.validationSubGroupId === ArcTimeLineValidationTypes.CanvasFormComment &&
					res[ArcTimeLineValidationTypes.CanvasFormComment] !== undefined &&
					res[ArcTimeLineValidationTypes.AddressAllOpenReviewNotes] === undefined
				) {
					res[ArcTimeLineValidationTypes.AddressAllOpenReviewNotes] = {
						validationsubgroupid: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
						validationcount: 0,
						validationgroupid: value.validationGroupId,
						id: value.id,
						validationTypeId: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes
					};
					result.push(res[ArcTimeLineValidationTypes.AddressAllOpenReviewNotes]);
					delete res[60];
				}

				// having both types. => all addition to adressAllOpenReviewNotes
				if (value.validationSubGroupId === ArcTimeLineValidationTypes.CanvasFormComment) {
					res[ArcTimeLineValidationTypes.AddressAllOpenReviewNotes].validationcount =
						value.validationCount + res[ArcTimeLineValidationTypes.AddressAllOpenReviewNotes].validationcount;
				} else {
					//just AddressAllOpenReviewNotes
					res[value.validationSubGroupId].validationcount += value.validationCount;
				}
				break;
			default:
				res[value.validationSubGroupId].validationcount += value.validationCount;
				break;
		}
		return res;
	}, {});

	result.forEach(deleteCanvasFormComment);

	function deleteCanvasFormComment(value, index) {
		if (value.validationsubgroupid === ArcTimeLineValidationTypes.CanvasFormComment) result.splice(index, 1);
	}

	let groups = [...new Set(result.map((x) => x.validationgroupid))];
	const l = groups.length;
	let byGroup = {};

	for (let i = 0; i < l; i++) {
		let items = result.filter((g) => g.validationgroupid === groups[i]);
		byGroup[groups[i]] = items;
	}

	byGroup.isLoaded = true;
	return byGroup;
};
